<template>
  <div class="absolute-center">
    <h5 class="q-my-md text-weight-light">
      Ошибка (код: <q-badge color="red-7" class="text-h5">{{ error?.statusCode }}</q-badge>)
    </h5>
    <div>
      <q-btn color="primary" class="full-width" label="На Главную" @click="handleError"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps({
  error: {
    type: Object as () => NuxtError,
    default: undefined
  }
})

const handleError = () => clearError({ redirect: '/' })
</script>
